<template>
  <v-combobox
    dense
    v-model="selected"
    :items="items"
    small-chips
    :label="$t('selectGuards')"
    :hint="$t('selectGuardsHint')"
    persistent-hint
    item-text="display"
    hide-no-data
    hide-selected
    multiple
    :menu-props="{
      closeOnClick: true,
      closeOnContentClick: true,
      openOnClick: false
    }"
  >
    <template slot="selection" slot-scope="{ selected, item }">
      <v-chip :selected="selected" close small @input="remove(item)">
        {{ item.display }}
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    items: Array,
    selection: Array,
    updateSelection: Function
  },
  computed: {
    selected: {
      get() {
        return this.selection.map((option) => this.items.find((item) => item.name === option))
      },
      set(value) {
        this.updateSelection(value.map((item) => item.name))
      }
    }
  },
  methods: {
    remove(option) {
      this.selected = this.selected.filter((item) => item.name !== option.name)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "selectGuards": "Select Guards",
    "selectGuardsHint": "Select the guards you want to protect this transition"
  },
  "fr": {
    "selectGuards": "Choisir les gardes",
    "selectGuardsHint": "Choisissez les gardes qui protègent cette transition"
  }
}
</i18n>
